export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtVyrobekvoz';
export const NAME = 'VyrobekVoz';
